import React from 'react';
import { CheckIcon, CreditCardIcon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../constants/checkout';
const items = ['Complete Box Set (6 volumes / 360 pages)', '5 Strategic Bonuses (included free)', 'Full Proficiency Roadmap (A1 – C1)', 'Lifetime access to all materials', 'Instant digital access (High-res PDF)'];
const checkoutUrl = CHECKOUT_URL;
export function PricingSection() {
  return <section id="pricing" className="bg-[#FAFAFA] px-5 py-20 pb-[05px] pt-[05px]" data-id="element-135" data-mp="1s9n7i0799t39">
      <div className="mx-auto max-w-xl text-center" data-id="element-136" data-mp="1x8qbrifevva6">
        <p className="inline-block bg-[#0A0A0A] px-4 py-2 text-xs font-bold uppercase tracking-widest text-white" data-id="element-137" data-mp="1xa1d7bldwqy4">
          Limited-time offer
        </p>
        <h2 className="mt-5 font-display text-4xl font-bold uppercase leading-none text-[#0A0A0A] sm:text-5xl" data-id="element-138" data-mp="2uyvi02kud5r">
          Everything included,{' '}
          <span className="text-[#b18b18]" data-id="element-139" data-mp="7ubqj83lqqjf">one single price.</span>
        </h2>
        <p className="mt-3 text-sm font-semibold text-[#5A5A66]" data-id="element-140" data-mp="1mhq069cetegb">
          No subscriptions. No hidden costs.
        </p>
        <article className="mt-10 overflow-hidden border border-[#E5E5EA] bg-white text-center shadow-xl" data-id="element-141" data-mp="1hon6803q02zl">
          <header className="border-t-4 border-[#d4af37] bg-[#0A0A0A] px-6 py-7" data-id="element-142" data-mp="1cr4y2bxj1rsn">
            <h3 className="font-display text-3xl font-bold uppercase text-white" data-id="element-143" data-mp="17td3fa5hzrkr">
              Italiano Ready™ — Complete Box Set
            </h3>
            <p className="mt-2 text-sm font-semibold text-[#d4af37]" data-id="element-144" data-mp="20gpfgqe18gzt">
              1 Main Box Set (6 volumes) + 5 Strategic Bonuses
            </p>
          </header>
          <div className="p-7 sm:p-10" data-id="element-145" data-mp="1vjft5jlxwlg7">
            <div id="offer-details" className="mb-8 scroll-mt-3 border-y border-[#E5E5EA] py-7" data-id="element-146" data-mp="1rgaqnh1v0jrk">
              <p className="mb-5 text-xs font-bold uppercase tracking-widest" data-id="element-147" data-mp="k3r6ktcllofx">
                What's included
              </p>
              <ul className="grid gap-3 text-left sm:grid-cols-2" data-id="element-148" data-mp="g2ywjxvwjfil">
                {items.map(item => <li key={item} className="flex items-center gap-2 text-sm font-semibold" data-id="element-149" data-mp="mgundo0fhlgv">
                    <span className="grid h-5 w-5 shrink-0 place-items-center rounded-full bg-[#d4af37]/20" data-id="element-150" data-mp="7isjtdteczzm">
                      <CheckIcon className="h-3.5 w-3.5 text-[#9b7914]" data-id="element-151" data-mp="ch3t9nfs58hb" />
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="mt-7" data-id="element-152" data-mp="3jbc0dqhzqra">
              <p className="text-sm font-semibold text-[#5A5A66]" data-id="element-153" data-mp="3kyi71znt8gzx">
                Regular price: <s data-id="element-154" data-mp="3kwnhg81lg0pi">$97 USD</s>
              </p>
              <div className="mt-1 flex items-baseline justify-center" data-id="element-155" data-mp="3pwrxjwylatf7">
                <span className="font-display text-5xl font-bold" data-id="element-156" data-mp="3by23kq72h9v2">$</span>
                <strong className="font-display text-8xl font-bold leading-none tracking-tight" data-id="element-157" data-mp="3bzwmjyys2rwi">
                  27
                </strong>
                <span className="ml-2 text-sm font-bold text-[#5A5A66]" data-id="element-158" data-mp="2xabi3ou9gps6">
                  USD
                </span>
              </div>
              <div className="mt-3 flex flex-wrap justify-center gap-3" data-id="element-159" data-mp="2sdutyun2abf3">
                <span className="bg-[#d4af37] px-3 py-1.5 text-xs font-bold uppercase tracking-widest" data-id="element-160" data-mp="36cugnwr0kg8m">
                  Save $70
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-[#5A5A66]" data-id="element-161" data-mp="3g9z7i9vt0zvr">
                  One-time payment
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-[#5A5A66]" data-id="element-162" data-mp="3bacua0fz7jmy">
                  Lifetime access
                </span>
              </div>
            </div>
            <a href={checkoutUrl} className="cta-button -mx-2 mt-6 block w-[calc(100%+1rem)] rounded-2xl px-6 py-6 text-lg font-bold sm:text-2xl" data-id="element-163" data-mp="3l1yzng5muohs">
              GET ITALIANO READY™ NOW
            </a>
            <p className="mt-5 flex items-center justify-center gap-1.5 text-xs font-semibold text-[#5A5A66]" data-id="element-164" data-mp="3tzj7j7y03j1d">
              <ShieldCheckIcon className="h-4 w-4 text-[#b18b18]" data-id="element-165" data-mp="lzftlegnse9t" />
              Backed by our 7-day money-back guarantee
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 border-t border-[#E5E5EA] pt-6 text-xs font-bold text-[#5A5A66]" data-id="element-166" data-mp="qrpeuh6twq5r">
              <span className="flex gap-1" data-id="element-167" data-mp="vrbropiqw4e1">
                <LockKeyholeIcon className="h-4 w-4" data-id="element-168" data-mp="3v5nx60ej04d9" />
                Secure payment
              </span>
              <span className="flex gap-1" data-id="element-169" data-mp="31lbmaxjysfa">
                <ZapIcon className="h-4 w-4" data-id="element-170" data-mp="32mxlag3wzbs" />
                Instant access
              </span>
              <span className="flex gap-1" data-id="element-171" data-mp="829b7kzukhl4">
                <CreditCardIcon className="h-4 w-4" data-id="element-172" data-mp="d013ig4em5pu" />
                Card · GooglePay · ApplePay
              </span>
            </div>
          </div>
        </article>
        <p className="mt-5 text-xs font-semibold text-[#5A5A66]" data-id="element-173" data-mp="1oe6cxondz7sk">
          You’ll be charged in your local currency.
        </p>
      </div>
    </section>;
}